/**
 * 门店实时数据 API 服务
 *
 * 请求方式：
 * 1. 整店数据：GET /api/store-revenue/data?hotelId=xxx
 *    - 页面加载时先加载 5 个门店（每个门店一次请求整店数据），滑动到底部懒加载更多，刷新某门店再次请求整店数据
 * 2. 单组件数据：GET /api/store-revenue/component?hotelId=xxx&componentType=xxx
 *    - 按需拉取单个组件（如 room-status、order-traffic）时使用
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
/** 门店营收后端 API 的请求头：Token 全部由后端 getStableToken() 处理，前端不传；禁用缓存避免 304 返回旧空数据 */
function storeRevenueHeaders() {
    var win = typeof globalThis !== 'undefined' &&
        'window' in globalThis
        ? globalThis.window
        : undefined;
    var isScreenshotMode = !!win &&
        new URLSearchParams(win.location.search).get('screenshot') === '1';
    if (isScreenshotMode) {
        return {
            'Content-Type': 'application/json',
        };
    }
    return {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
    };
}
/**
 * 已废弃：Token 全部由后端处理，前端不再获取或传递 token。
 * 保留此方法仅为兼容旧调用，直接返回 null，调用方应改为走后端接口。
 */
export function ensureStoreRevenueToken() {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, null];
        });
    });
}
/**
 * 前端直调 PMS 业务报告列表（用于 RevPAR 等）
 * GET {BASE}/qiuguo-pms/pms/mainReport/businessReportList?hotelId=xxx&dateType=0|1&startDate=YYYY-MM-DD&endDate=YYYY-MM-DD
 */
/**
 * 业务报告：走后端代理（后端统一调 PMS 并写 Redis）
 * GET /api/store-revenue/proxy/business-report?hotelId=xxx&dateType=0&startDate=&endDate=
 */
export function getBusinessReportListFromThirdParty(hotelId, params) {
    var _a, _b, _c, _d, _e, _f, _g;
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/business-report', {
                        params: {
                            hotelId: String(hotelId),
                            dateType: params.dateType,
                            startDate: params.startDate,
                            endDate: params.endDate,
                            pageNum: (_a = params.pageNum) !== null && _a !== void 0 ? _a : 1,
                            pageSize: (_b = params.pageSize) !== null && _b !== void 0 ? _b : 500,
                        },
                        timeout: 30000,
                    })];
                case 1:
                    response = _h.sent();
                    if (((_c = response.data) === null || _c === void 0 ? void 0 : _c.code) !== 1) {
                        throw new Error((_e = (_d = response.data) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : '业务报告接口异常');
                    }
                    if (!((_g = (_f = response.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.list))
                        return [2 /*return*/, []];
                    return [2 /*return*/, response.data.data.list];
            }
        });
    });
}
/**
 * 按组件名获取该组件的四时间段数据
 * 后端约定：传 hotelId + componentType + timeDirection，返回 { timeDirection, current, last7Days, last30Days, last12Months }
 * 接口：GET /api/store-revenue/component-data?hotelId=xxx&componentType=xxx&timeDirection=past|future
 */
export function getComponentDataByTimeRanges(hotelId, componentType, timeDirection) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (timeDirection === void 0) { timeDirection = 'past'; }
    return __awaiter(this, void 0, Promise, function () {
        var url, response, error_1;
        return __generator(this, function (_p) {
            switch (_p.label) {
                case 0:
                    url = '/api/store-revenue/component-data';
                    _p.label = 1;
                case 1:
                    _p.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get(url, {
                            headers: storeRevenueHeaders(),
                            params: { hotelId: hotelId, componentType: componentType, timeDirection: timeDirection },
                        })];
                case 2:
                    response = _p.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data) != null) {
                        return [2 /*return*/, response.data.data];
                    }
                    throw new Error((_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : '获取组件四时间段数据失败');
                case 3:
                    error_1 = _p.sent();
                    if (((_e = error_1.response) === null || _e === void 0 ? void 0 : _e.status) === 503) {
                        throw new Error((_h = (_g = (_f = error_1.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.message) !== null && _h !== void 0 ? _h : '门店营收服务未配置 Token，请联系管理员');
                    }
                    if (((_j = error_1.response) === null || _j === void 0 ? void 0 : _j.status) === 401) {
                        throw new Error('Token 无效或已过期，请重新登录');
                    }
                    if (((_k = error_1.response) === null || _k === void 0 ? void 0 : _k.status) === 500) {
                        throw new Error((_o = (_m = (_l = error_1.response) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.message) !== null && _o !== void 0 ? _o : '组件数据服务暂时不可用，将使用本地数据');
                    }
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    });
}
/** FSM aliasCountList 响应 */
// 统一 baseUrl：所有前端直连第三方均用此方法，见 config/apiBaseUrl.ts
export { getFsmBaseUrl } from '../config/apiBaseUrl';
/**
 * 房态数据：优先走后端代理（后端统一调第三方并写 Redis），与 localStorage 分层缓存一致
 * GET /api/store-revenue/proxy/room-status?hotelId=xxx
 */
export function getRoomStatusFromThirdParty(hotelId) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/room-status', { params: { hotelId: hotelId }, timeout: 20000 })];
                case 1:
                    response = _c.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && Array.isArray((_b = response.data) === null || _b === void 0 ? void 0 : _b.data))
                        return [2 /*return*/, response.data.data];
                    return [2 /*return*/, []];
            }
        });
    });
}
/**
 * 近期房型房价：过去 24 小时 + 过去 7 天两组挂牌价
 * GET /api/store-revenue/proxy/hourly-price-by-room?hotelId=xxx
 */
export function getHourlyPriceByRoomFromProxy(hotelId) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/hourly-price-by-room', { params: { hotelId: hotelId }, timeout: 30000 })];
                case 1:
                    response = _c.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data))
                        return [2 /*return*/, response.data.data];
                    return [2 /*return*/, { dataSource: [] }];
            }
        });
    });
}
/** 房态健康：过去 7 天 / 30 天 / 12 个月三组 */
export function getRoomHealthFromProxy(hotelId) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var response, empty;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/room-health', { params: { hotelId: hotelId }, timeout: 60000 })];
                case 1:
                    response = _c.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data))
                        return [2 /*return*/, response.data.data];
                    empty = {
                        chartData: { categories: [], dataset: {}, axes: { left: { id: 'left', position: 'left', name: '房间数', unit: '间', min: 0, max: 100 } }, series: [] },
                    };
                    return [2 /*return*/, { last7Days: empty, last30Days: empty, last12Months: empty }];
            }
        });
    });
}
export function getChannelInfoFromProxy(hotelId) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var response, empty, block;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/channel-info', { params: { hotelId: hotelId }, timeout: 60000 })];
                case 1:
                    response = _c.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data))
                        return [2 /*return*/, response.data.data];
                    empty = {
                        categories: [],
                        dataset: { volume: [], customerUnitPrice: [] },
                        axes: {
                            left: { id: 'left', position: 'left', name: '订单量', unit: '单', min: 0, max: 220 },
                            right: { id: 'right', position: 'right', name: '客单价', unit: '元', min: 0, max: 3100 },
                        },
                        series: [],
                    };
                    block = { chartData: empty };
                    return [2 /*return*/, { last7Days: block, last30Days: block, last12Months: block }];
            }
        });
    });
}
export function getRevparFromProxy(hotelId) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var response, emptyChart, block;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/revpar', { params: { hotelId: hotelId }, timeout: 60000 })];
                case 1:
                    response = _c.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data))
                        return [2 /*return*/, response.data.data];
                    emptyChart = {
                        categories: [],
                        dataset: { priceKlineData: [], RevPAR: [], RevPARLastYear: [] },
                        axes: {
                            left: { id: 'left', position: 'left', name: '可售房收入', unit: '元', min: 0, max: 100 },
                        },
                        series: [],
                    };
                    block = { chartData: emptyChart };
                    return [2 /*return*/, { last7Days: block, last30Days: block, last12Months: block }];
            }
        });
    });
}
export function getChannelAnalysisFromProxy(hotelId) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var response, empty, block;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/channel-analysis', { params: { hotelId: hotelId }, timeout: 60000 })];
                case 1:
                    response = _c.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data))
                        return [2 /*return*/, response.data.data];
                    empty = {
                        categories: [],
                        dataset: { roomNights: [], rates: [], revenue: [] },
                        axes: {
                            left: { id: 'left', position: 'left', name: '间夜数', unit: '间', min: 0, max: 100 },
                            right: { id: 'right', position: 'right', name: '收入', unit: '元', min: 0, max: 10000 },
                        },
                        series: [],
                    };
                    block = { chartData: empty };
                    return [2 /*return*/, { last7Days: block, last30Days: block, last12Months: block }];
            }
        });
    });
}
export function getOperationEfficiencyFromProxy(hotelId) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var response, empty, block;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/operation-efficiency', { params: { hotelId: hotelId }, timeout: 60000 })];
                case 1:
                    response = _c.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data))
                        return [2 /*return*/, response.data.data];
                    empty = {
                        categories: [],
                        dataset: { earlyCheckout: [], noshow: [], orderTake: [], ratio: [] },
                        axes: {
                            left: { id: 'left', position: 'left', name: '数量', unit: '间', min: 0, max: 100 },
                            right: { id: 'right', position: 'right', name: '非正常占比', unit: '%', min: 0, max: 100 },
                        },
                        series: [],
                    };
                    block = { chartData: empty };
                    return [2 /*return*/, {
                            last7Days: block,
                            last30Days: block,
                            last12Months: block,
                            next7Days: block,
                            next30Days: block,
                        }];
            }
        });
    });
}
export function getCustomerSourceFromProxy(hotelId) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var response, empty, block;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/customer-source', { params: { hotelId: hotelId }, timeout: 60000 })];
                case 1:
                    response = _c.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data))
                        return [2 /*return*/, response.data.data];
                    empty = {
                        categories: [],
                        dataset: { fit: [], team: [], member: [], unit: [], ota: [], intro: [], occupancyRate: [] },
                        axes: {
                            left: { id: 'left', position: 'left', name: '间夜数', unit: '间', min: 0, max: 100 },
                            right: { id: 'right', position: 'right', name: '出租率', unit: '%', min: 0, max: 130 },
                        },
                        series: [],
                    };
                    block = { chartData: empty };
                    return [2 /*return*/, {
                            last7Days: block,
                            last30Days: block,
                            last12Months: block,
                            next7Days: block,
                            next30Days: block,
                        }];
            }
        });
    });
}
export function getDiscountAnalysisFromProxy(hotelId) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var response, empty, block;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/discount-analysis', { params: { hotelId: hotelId }, timeout: 60000 })];
                case 1:
                    response = _c.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data))
                        return [2 /*return*/, response.data.data];
                    empty = {
                        categories: [],
                        dataset: { discountRate: [], occupancyRate: [], avgListPrice: [], avgPrice: [] },
                        axes: {
                            left: { id: 'left', position: 'left', name: '出租率', unit: '%', min: 0, max: 130 },
                            right: { id: 'right', position: 'right', name: '价格', unit: '元', min: 0, max: 1000 },
                            right2: { id: 'right2', position: 'right', name: '折扣率', unit: '%', min: 0, max: 100 },
                        },
                        series: [],
                    };
                    block = { chartData: empty };
                    return [2 /*return*/, {
                            last7Days: block,
                            last30Days: block,
                            last12Months: block,
                            next7Days: block,
                            next30Days: block,
                        }];
            }
        });
    });
}
export function getOrderTrafficFromProxy(hotelId) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var response, empty;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/order-traffic', { params: { hotelId: hotelId }, timeout: 60000 })];
                case 1:
                    response = _c.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data))
                        return [2 /*return*/, response.data.data];
                    empty = {
                        categories: [],
                        dataset: {
                            channel1Orders: [],
                            channel2Orders: [],
                            channel3Orders: [],
                            channel4Orders: [],
                            averagePrice: [],
                        },
                        axes: {
                            left: { id: 'left', position: 'left', name: '订单量', unit: '单', max: 100 },
                            right: { id: 'right', position: 'right', name: '平均价格', unit: '元', min: 0, max: 1000 },
                        },
                        series: [],
                        comparison: { yearOverYear: 0, weekOverWeek: 0 },
                    };
                    return [2 /*return*/, { last24Hours: empty, last7Days: empty }];
            }
        });
    });
}
export function getOccupancyAnalysisFromProxy(hotelId) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var response, empty;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/occupancy-analysis', { params: { hotelId: hotelId }, timeout: 60000 })];
                case 1:
                    response = _c.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data))
                        return [2 /*return*/, response.data.data];
                    empty = {
                        chartData: {
                            categories: [],
                            dataset: { occupancyRate: [], roomOvernightRate: [], hourScale: [], roomNight: [] },
                            axes: { left: { id: 'left', position: 'left', name: '出租率', unit: '%', min: 0, max: 150 } },
                            series: [],
                        },
                    };
                    return [2 /*return*/, { last7Days: empty, last30Days: empty, last12Months: empty }];
            }
        });
    });
}
/**
 * 远期房态：走后端代理（后端统一调 FSM 并写 Redis）
 * GET /api/store-revenue/proxy/future-room-status?hotelId=xxx&startDate=&endDate=
 */
export function getFutureRoomStatusListFromThirdParty(hotelId, startDate, endDate) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var params, response;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    params = { hotelId: String(hotelId) };
                    if (startDate)
                        params.startDate = startDate;
                    if (endDate)
                        params.endDate = endDate;
                    return [4 /*yield*/, axios.get('/api/store-revenue/proxy/future-room-status', { params: params, timeout: 20000 })];
                case 1:
                    response = _c.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && Array.isArray((_b = response.data) === null || _b === void 0 ? void 0 : _b.data))
                        return [2 /*return*/, response.data.data];
                    return [2 /*return*/, []];
            }
        });
    });
}
/**
 * 获取门店完整实时数据
 * 后端已做「由树构建的响应」缓存与预热，请求应快速返回，不再做前端限流。
 */
export function getStoreRevenueData(params) {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, Promise, function () {
        var queryParams, url, response, error_2;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    queryParams = {
                        hotelId: params.hotelId,
                    };
                    if (params.startDate != null) {
                        queryParams.startDate = params.startDate;
                    }
                    url = '/api/store-revenue/data';
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get(url, {
                            headers: storeRevenueHeaders(),
                            params: queryParams,
                        })];
                case 2:
                    response = _f.sent();
                    if (response.data.code === 1 && response.data.data) {
                        return [2 /*return*/, response.data.data];
                    }
                    throw new Error(response.data.message || '获取门店实时数据失败');
                case 3:
                    error_2 = _f.sent();
                    if (((_a = error_2.response) === null || _a === void 0 ? void 0 : _a.status) === 503) {
                        throw new Error((_d = (_c = (_b = error_2.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : '门店营收服务未配置 Token，请联系管理员');
                    }
                    if (((_e = error_2.response) === null || _e === void 0 ? void 0 : _e.status) === 401) {
                        throw new Error('Token 无效或已过期，请重新登录');
                    }
                    throw error_2;
                case 4: return [2 /*return*/];
            }
        });
    });
}
/** 进行中请求合并：同一 hotelId 只发一次 store-data-from-cache，避免 Strict Mode 或重复挂载导致重复请求 */
var inFlightStoreDataFromCache = new Map();
/**
 * 仅从后端缓存获取门店数据（订单 + 业务报告），不调第三方；与前端直调的房态、渠道价合并使用。
 * GET /api/store-revenue/store-data-from-cache?hotelId=xxx；同门店进行中只发一次请求。
 */
export function getStoreDataFromCacheFromBackend(hotelId) {
    return __awaiter(this, void 0, Promise, function () {
        var key, inFlight, promise;
        var _this = this;
        return __generator(this, function (_a) {
            key = String(hotelId);
            inFlight = inFlightStoreDataFromCache.get(key);
            if (inFlight)
                return [2 /*return*/, inFlight];
            promise = (function () { return __awaiter(_this, void 0, Promise, function () {
                var url, response, data, fetchedAt, setStoreDataFromCacheWithComponentSlices, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            url = '/api/store-revenue/store-data-from-cache';
                            return [4 /*yield*/, axios.get(url, {
                                    headers: storeRevenueHeaders(),
                                    params: { hotelId: hotelId },
                                })];
                        case 1:
                            response = _b.sent();
                            if (!(response.data.code === 1 && response.data.data)) return [3 /*break*/, 6];
                            data = response.data.data;
                            fetchedAt = Date.now();
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, import('../monitor/utils/storeRevenueLocalStorage')];
                        case 3:
                            setStoreDataFromCacheWithComponentSlices = (_b.sent()).setStoreDataFromCacheWithComponentSlices;
                            setStoreDataFromCacheWithComponentSlices(hotelId, data, fetchedAt);
                            return [3 /*break*/, 5];
                        case 4:
                            _a = _b.sent();
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/, data];
                        case 6: throw new Error(response.data.message || '获取缓存门店数据失败');
                    }
                });
            }); })().finally(function () {
                inFlightStoreDataFromCache.delete(key);
            });
            inFlightStoreDataFromCache.set(key, promise);
            return [2 /*return*/, promise];
        });
    });
}
/**
 * 按指定预抵日期拉取订单并统计
 * GET /api/store-revenue/order-stats-by-date?hotelId=xxx&date=YYYY-MM-DD
 */
export function getOrderStatsByDate(hotelId, date) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/order-stats-by-date', { params: { hotelId: hotelId, date: date }, headers: storeRevenueHeaders() })];
                case 1:
                    response = _e.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data)) {
                        return [2 /*return*/, response.data.data];
                    }
                    throw new Error((_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : '获取订单统计失败');
            }
        });
    });
}
/**
 * 按在住日期范围拉取房单列表（单页，最多 500）
 * GET /api/store-revenue/order-room-page-list-by-date?hotelId=xxx&startDate=YYYY-MM-DD&endDate=YYYY-MM-DD
 */
export function getOrderRoomPageListByDate(hotelId, startDate, endDate) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, Promise, function () {
        var params, response;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    params = { hotelId: String(hotelId), startDate: startDate };
                    if (endDate)
                        params.endDate = endDate;
                    return [4 /*yield*/, axios.get('/api/store-revenue/order-room-page-list-by-date', {
                            params: params,
                            headers: storeRevenueHeaders(),
                        })];
                case 1:
                    response = _e.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data)) {
                        return [2 /*return*/, response.data.data];
                    }
                    throw new Error((_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : '获取房单列表失败');
            }
        });
    });
}
/**
 * GET /api/store-revenue/proxy/order-room-page-list?hotelId=&preset=
 * 后端调 FSM orderRoomPageList，Redis 缓存 10 分钟。
 */
export function getProxyOrderRoomPageListByPreset(hotelId, preset) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/order-room-page-list', {
                        params: { hotelId: hotelId, preset: preset },
                        headers: storeRevenueHeaders(),
                        timeout: 60000,
                    })];
                case 1:
                    response = _e.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data)) {
                        return [2 /*return*/, response.data.data];
                    }
                    throw new Error((_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : '获取房单列表失败');
            }
        });
    });
}
/**
 * 前端直调 COS「经营分析报表合计」获取指定门店、指定日期的当天平均价
 * GET {COS_BASE_URL}/qiuguo-cos/cos/report/groupBusinessReportTotal?hotelIds=xxx&startDate=YYYY-MM-DD&endDate=YYYY-MM-DD&dateType=0
 * 用于房态年同比/周环比辅助线，结果由调用方做本地缓存（按日更新）。
 */
/**
 * 指定日期平均价：走后端代理（后端统一调 COS 并写 Redis）
 * GET /api/store-revenue/proxy/avg-price?hotelId=xxx&date=YYYY-MM-DD
 * 请求头禁用缓存，避免 304 使用旧空数据导致页面无数据
 */
export function getAvgPriceByDateFromThirdParty(hotelId, date) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/avg-price', { params: { hotelId: hotelId, date: date }, timeout: 15000, headers: storeRevenueHeaders() })];
                case 1:
                    response = _c.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data)) {
                        return [2 /*return*/, { date: response.data.data.date, avgPrice: response.data.data.avgPrice }];
                    }
                    return [2 /*return*/, { date: date, avgPrice: 0 }];
            }
        });
    });
}
/**
 * 获取指定门店、指定日期的当天平均价（前端直调 COS groupBusinessReportTotal，结果由调用方本地缓存）
 */
export function getAvgPriceByDate(hotelId, date) {
    return __awaiter(this, void 0, Promise, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getAvgPriceByDateFromThirdParty(hotelId, date)];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    _a = _b.sent();
                    return [2 /*return*/, { date: date, avgPrice: 0 }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * 批量获取多日平均价（用于远期房态年同比/周环比折线）
 * 内部复用 getAvgPriceByDate，按日期顺序返回 avgPrice 数组
 */
export function getAvgPricesByDates(hotelId, dates) {
    return __awaiter(this, void 0, Promise, function () {
        var results;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dates.length)
                        return [2 /*return*/, []];
                    return [4 /*yield*/, Promise.all(dates.map(function (date) { return getAvgPriceByDate(hotelId, date); }))];
                case 1:
                    results = _a.sent();
                    return [2 /*return*/, results.map(function (r) { return r.avgPrice; })];
            }
        });
    });
}
/**
 * 前端直调 PMS「按渠道获取房型价格」
 * GET {COS_BASE_URL}/qiuguo-pms/pms/hotelRoomPrice/getRoomPriceByChannel?hotelId=xxx&startDate=yyyy-mm-dd&endDate=yyyy-mm-dd
 * 传参为当天日期 yyyy-mm-dd，用于渠道房型价格组件，结果由调用方做本地缓存。
 */
/**
 * 渠道房型价格：走后端代理（后端统一调 PMS 并写 Redis），返回与直调一致的规范化结构
 * GET /api/store-revenue/proxy/channel-price?hotelId=xxx
 */
export function getChannelPriceFromThirdParty(hotelId) {
    var _a, _b, _c;
    return __awaiter(this, void 0, Promise, function () {
        var response, raw, normalizeChannelPriceApiToResponse;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, axios.get('/api/store-revenue/proxy/channel-price', { params: { hotelId: hotelId }, timeout: 30000 })];
                case 1:
                    response = _d.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) !== 1)
                        return [2 /*return*/, null];
                    raw = (_b = response.data) === null || _b === void 0 ? void 0 : _b.data;
                    return [4 /*yield*/, import('../monitor/utils/priceChannelDataTransformer')];
                case 2:
                    normalizeChannelPriceApiToResponse = (_d.sent()).normalizeChannelPriceApiToResponse;
                    return [2 /*return*/, normalizeChannelPriceApiToResponse({ code: (_c = raw === null || raw === void 0 ? void 0 : raw.code) !== null && _c !== void 0 ? _c : 0, data: raw === null || raw === void 0 ? void 0 : raw.data }, hotelId)];
            }
        });
    });
}
/**
 * 前端直调 PMS「获取酒店房型房态最高价、最低价、房量（最多查询 7 天）」
 * GET {COS_BASE_URL}/qiuguo-pms/pms/api/getAliasPriceQuantity?hotelId=xxx&startDate=xxx&endDate=xxx
 * 传参为 Unix 时间戳（秒）。默认查询「未来 7 天（含今天）」：当天 0 点 至 今天+6 天 0 点。
 */
export function getAliasPriceQuantityFromThirdParty(hotelId, startDate, endDate) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var start, end, today, endDay, response;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (endDate != null && startDate != null) {
                        start = startDate;
                        end = endDate;
                    }
                    else {
                        today = new Date();
                        today.setHours(0, 0, 0, 0);
                        start = startDate !== null && startDate !== void 0 ? startDate : Math.floor(today.getTime() / 1000);
                        endDay = new Date(today);
                        endDay.setDate(endDay.getDate() + 6);
                        endDay.setHours(0, 0, 0, 0);
                        end = endDate !== null && endDate !== void 0 ? endDate : Math.floor(endDay.getTime() / 1000);
                    }
                    return [4 /*yield*/, axios.get('/api/store-revenue/proxy/room-status-recently', { params: { hotelId: String(hotelId), startDate: start, endDate: end }, timeout: 30000 })];
                case 1:
                    response = _c.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data))
                        return [2 /*return*/, response.data.data];
                    return [2 /*return*/, { code: 0, data: [] }];
            }
        });
    });
}
/**
 * 按组件获取门店数据（单独接口）
 * GET /api/store-revenue/component?hotelId=xxx&componentType=xxx
 * @returns 单块数据，如 { roomStatus: ... } 或 { orderTraffic: ... }
 */
export function getStoreRevenueComponent(hotelId, componentType) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, Promise, function () {
        var url, response;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    url = '/api/store-revenue/component';
                    return [4 /*yield*/, axios.get(url, {
                            headers: storeRevenueHeaders(),
                            params: { hotelId: hotelId, componentType: componentType },
                        })];
                case 1:
                    response = _e.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data) != null) {
                        return [2 /*return*/, response.data.data];
                    }
                    throw new Error((_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : '获取门店组件数据失败');
            }
        });
    });
}
/**
 * 按组件获取门店数据（兼容旧用法，走 /data?componentType=xxx）
 * GET /api/store-revenue/data?hotelId=xxx&componentType=room-status
 * @returns 单块数据，如 { roomStatus: ... } 或 { orderTraffic: ... }
 */
export function getStoreRevenueDataByComponent(hotelId, componentType) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, Promise, function () {
        var url, response;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    url = '/api/store-revenue/data';
                    return [4 /*yield*/, axios.get(url, {
                            headers: storeRevenueHeaders(),
                            params: { hotelId: hotelId, componentType: componentType },
                        })];
                case 1:
                    response = _e.sent();
                    if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === 1 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data) != null) {
                        return [2 /*return*/, response.data.data];
                    }
                    throw new Error((_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : '获取门店组件数据失败');
            }
        });
    });
}
